module.exports = __webpack_public_path__ + "img/RecommendationAssessment.52d52366.png";